import AuthContextProvider from "./features/auth/context/authContext";
import ToastContextProvider, {ToastContainer} from "./layouts/toast";
import { ModeProvider } from "./features/supervision/conversations/components/ConversationProfil/ConversationCard/ModeContext/ModeContext";

function Providers({ children }) {
    // NiceModal.Provider now lives inside <Router> (inside <BrowserRouter>),
    // so modals get Router context (useNavigate/useLocation) - see Router.js.
    return (
        <ToastContextProvider>
            <AuthContextProvider>
                <ModeProvider>
                    <ToastContainer/>
                    { children }
                </ModeProvider>
            </AuthContextProvider>
        </ToastContextProvider>
    )
}

export default Providers;